
export enum IDeviationKeywords {
    WearAndTear,
    Taring,
    MaskBreakage,
    Breccia,
    ShrinkNot
}
